// Listens for the bp:session-expired CustomEvent dispatched by the
// API client when auth becomes unrecoverable, and routes to /login.
// Mounted once at the App root. Idempotent across React StrictMode
// double-effects.

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function SessionExpiryHandler() {
  const navigate = useNavigate();
  useEffect(() => {
    function onExpired() {
      // replace so the back button doesn't bounce into the protected
      // page the user was on when the token died.
      navigate("/login", { replace: true });
    }
    window.addEventListener("bp:session-expired", onExpired);
    return () => {
      window.removeEventListener("bp:session-expired", onExpired);
    };
  }, [navigate]);
  return null;
}
